import React from 'react';
import classNames from 'classnames';

import { Message } from '../../types';

import UserAvatar from '../UserAvatar';
import MessageBubble from './MessageBubble';

import styles from './MessageItem.module.css';

export function MessageItem({ message }: { message: Message }) {
  const { sender, isOutgoing } = message;

  return (
    <div
      className={classNames({
        [styles.messageItem]: true,
        [styles.outgoingMessage]: isOutgoing,
      })}
    >
      {!isOutgoing && <UserAvatar user={sender} />}
      <MessageBubble message={message} />
    </div>
  );
}

export default MessageItem;
